import React from 'react';
import type { AfcCandidateSearch } from '@axiom/validation';
import { CondensedLarge, Icon } from '@axiom/ui';

export const DiscoverTalentCarouselYearsOfExperience = ({
  candidate,
  name,
}: {
  candidate: AfcCandidateSearch;
  name?: string;
}) => {
  const candidateYOE = candidate.yearsOfExperience || 0;
  const yoe = Math.round(candidateYOE);
  let data = `${yoe} Year${yoe > 1 ? 's' : ''} of experience`;

  if (yoe === 0) {
    data = 'Less than 1 Year of experience';
  } else if (Math.floor(candidateYOE) >= 20) {
    data = '20+ Years of experience';
  }

  return (
    <>
      <Icon name="checkmark" />
      <CondensedLarge name={name || 'DISCOVER_CANDIDATE_EXPERIENCE'}>
        {data}
      </CondensedLarge>
    </>
  );
};
